import { Text } from '@deprecated-ui/common';
import { Popover } from 'antd';
import Image from 'global/Image';
import { PopoverInfoContainer } from './styled';

const PopoverInfo = () => (
  <Popover
    content={
      <PopoverInfoContainer>
        <Text>
          Daftar saham yang dapat ditransaksikan menggunakan Trading Limit
          dengan persentase haircut untuk setiap saham.
          <br />
          <br />
          Semakin tinggi persentase haircut, semakin kecil nilai saham yang
          dianggap sebagai jaminan. Haircut 100% berarti saham tersebut tidak
          dapat digunakan sebagai jaminan.
        </Text>
      </PopoverInfoContainer>
    }
    destroyTooltipOnHide
  >
    <Image src="/icon/info-circle-grey.svg" width="18" height="18" />
  </Popover>
);

export default PopoverInfo;
